import React from 'react';
import IntroduceProgram from './introduceProgram';
import RequestConsult from './component/requestConsult';

const ProgramsPage : React.FC = () => (
  <div>
    <IntroduceProgram />
    <RequestConsult />

  </div>
);

export default ProgramsPage;
